// Match the browser state written by the Auth0 SPA SDK, independently of the
// authentication provider now returned by the backend.
const getSessionCookieNames = (clientId: string): string[] => {
    const names = ['auth0.is.authenticated', `auth0.${clientId}.is.authenticated`];
    return [...names, ...names.map((name) => `_legacy_${name}`)];
};

export const hasLegacyAuth0Session = (clientId: string): boolean => {
    const cookieNames = document.cookie.split(';').map((cookie) => cookie.trim().split('=')[0]);
    if (getSessionCookieNames(clientId).some((name) => cookieNames.includes(name))) return true;

    const cachePrefix = `@@auth0spajs@@::${clientId}::`;
    return Object.keys(localStorage).some((key) => key.startsWith(cachePrefix));
};

export const clearLegacyAuth0Session = (clientId: string): void => {
    const transactionKey = `a0.spajs.txs.${clientId}`;
    const cookieNames = [
        ...getSessionCookieNames(clientId),
        `auth0.${clientId}.organization_hint`,
        `_legacy_auth0.${clientId}.organization_hint`,
        transactionKey,
        `_legacy_${transactionKey}`,
    ];

    // The app used Auth0's default host-only cookies with path=/.
    cookieNames.forEach((name) => {
        document.cookie = `${name}=; Max-Age=0; Path=/`;
    });
    sessionStorage.removeItem(transactionKey);
    const cachePrefix = `@@auth0spajs@@::${clientId}::`;
    Object.keys(localStorage)
        .filter((key) => key.startsWith(cachePrefix))
        .forEach((key) => localStorage.removeItem(key));
};
